module.exports = __webpack_public_path__ + "static/media/direct-selection.3f960648.png";